import React from "react";

import construction from 'assets/img/construction.gif'

class Construction extends React.Component {
  render() {
    return (
        <div style={{ padding: 40 }}>
            <img height={148} width={249} src={construction} style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        </div>
    );
  }
}

export default Construction;